export const THINGAMABOB_SET_PROP = "thingamabob_set_prop";
export const THINGAMABOB_SET_ACTIONS = "thingamabob_set_actions";
export const THINGAMABOB_CLEAR_ACTIONS = "thingamabob_clear_actions";
